import React, { useContext, useState } from "react";
import PackageUpdateForm from "../components/purchases/PackageUpdateForm";
import { AuthContext } from "../context/AuthContext";
import { ModalContext } from "../context/ModalContext";
import { navigate } from "@reach/router";

const ClassPackageUpdate = () => {
  const [selection, setSelection] = useState("");

  const { success } = useContext(ModalContext);
  const { user, updateUsuario } = useContext(AuthContext);

  const handleSubmit = () => {
    updateUsuario(
      {
        ...user,
        acceptedPackageUpdate: selection,
        acceptedPackageUpdateAt: new Date(),
      },
      false,
      () => {
        success("Gracias por tu confirmación.");
        navigate("/mytbm/presencial");
      }
    );
   
  };

  return (
    <div className="container-fluid px-md-5 px-3">
      <div className="container px-0 shadow mt-5" style={{ maxWidth: 1000 }}>
        <div className="bg-light p-md-5 p-4 text-center">
          <h1 className="display-4 bold package-update-title">
            Nuevos paquetes + <br />
            nuevos beneficios
          </h1>
          <div style={{ maxWidth: 600 }} className="m-auto text-large">
            <p>
              Actualizamos nuestros paquetes para que tengas más claridad, más
              valor y mejores herramientas de progreso.
            </p>
            <p className="mb-0">
              A partir del <span className="bold text-primary">28/01/2026</span>{" "}
              entran los nuevos paquetes TBM Para que tú elijas lo que más te
              conviene, necesitamos tu confirmación:
            </p>
          </div>
        </div>
        <img
          src="/img/paquetes-2026.jpg"
          alt="Paquetes 2026"
          className="mw-100 w-100 d-block m-auto"
        />
        <div className="bg-light p-md-5 p-4">
          <div style={{ maxWidth: 600 }} className="m-auto">
            <h3 className="text-center">
              Además, también incluimos nuevos beneficios:
            </h3>
            <ul className="large ps-2" style={{ listStyleType: "none" }}>
              <li className="mb-4">
                <i className="fa fa-check-circle text-primary me-2" />
                <b>First Timer Bonus:</b> en tu primer mes, +2 créditos en paquetes de
                8 clases en adelante. (Válido solo para primera compra. Créditos
                extra válidos solo en e primer ciclo de 30 días).
              </li>
              <li className="mb-4">
                <i className="fa fa-check-circle text-primary me-2" />
                <b>Rollover:</b> acumula hasta 4 clases para el mes siguiente (solo en
                planes con rollover).
              </li>
              <li className="mb-4">
                <i className="fa fa-check-circle text-primary me-2" />
                <b>Progress Check:</b> Medidas de circunferencias + bioimpedancia
                (peso, % grasa, % masa muscular y % grasa visceral) + rangos de referencia y recomendaciones por Vgnutricion.
              </li>
            </ul>
          </div>
        </div>
        <div className="bg-white p-md-5 p-4">
          <div style={{ maxWidth: 500 }} className="m-auto">
            <PackageUpdateForm
              selection={selection}
              setSelection={setSelection}
              handleSubmit={handleSubmit}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassPackageUpdate;
